<div class="gc-dg-container">
    <h2 class="gc-dg-text-2xl">A look at your plan</h2>
    <!-- Upper card, Purchase description and summary-->
    <div id="gc-dg-summary" class="gc-dg-d-flex"></div>
    <!-- Billing Address -->
    <div id="gc-dg-billing_address" class="gc-dg-d-flex"></div>
    <!-- Payment Tabs -->
    <div id="gc-dg-payment" class="gc-dg-d-flex"></div>
    <!-- payment start information  -->
    <div id="gc-dg-payment_information" class="gc-dg-d-flex"></div>
    <!-- Submit button to make payment  -->
    <div id="gc-dg-submit-button"></div>
</div>
